var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment-timezone');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var pagination = require('../../data/components/pagination');
var dragscroll = require('../../libs/dragscroll');
var session = require('../../auth/models/session');

var dateFormat = 'MM/DD/YYYY HH:mm';

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

var equipmentCommentModal = {
  comments: [],
  commentsToShow: [],
  commentText: prop(''),
  subjectRid: null,
  elementRid: null,
  reinitializeSmartTable: null,
  editingRid: prop(null),
  reinitializePagination: prop(false),
  pendingDeleteRecord: null,
  modalTitle: '',
  commentsLoadError: null,
  commentsLoading: false,
  
  open: function (equipmentRecord, options) {
    if (!equipmentRecord || !equipmentRecord['@rid']) return;
    equipmentCommentModal.submitCallback = null;
    if (options && options.submitCallback) {
      equipmentCommentModal.submitCallback = options.submitCallback;
    }
    equipmentCommentModal.elementRid = options && options.elementRid ? options.elementRid : null;
    equipmentCommentModal.subjectRid = equipmentRecord['@rid'];
    equipmentCommentModal.commentText('');
    equipmentCommentModal.comments = [];
    equipmentCommentModal.commentsToShow = [];
    equipmentCommentModal.editingRid(null);
    equipmentCommentModal.reinitializePagination(false);
    equipmentCommentModal.pendingDeleteRecord = null;
    equipmentCommentModal.commentsLoadError = null;
    equipmentCommentModal.commentsLoading = false;
    equipmentCommentModal.modalTitle = `Comments for ${equipmentRecord.name || equipmentRecord['@class'] }`;
    equipmentCommentModal.updateButtons();

    equipmentCommentModal.fetchComments();

    key.setScope('modal');
    modal.vm.title(equipmentCommentModal.modalTitle);
    modal.vm.body = equipmentCommentModal.view;
    modal.vm.open({ extrawidth: true });
  },

  fetchComments: function () {
    const rid = equipmentCommentModal.subjectRid;
    if (!rid) return Promise.resolve(null);
    equipmentCommentModal.commentsLoadError = null;
    equipmentCommentModal.commentsLoading = true;
    return loaders.requestWithLoader({
      url: `/api/v1/comment/subject/${rid.slice(1)}`,
      method: 'GET'
    }).then(function (result) {
      const filtered = (result || []).filter(r => !r.deleted);
      equipmentCommentModal.comments = filtered;
      equipmentCommentModal.commentsToShow = JSON.parse(JSON.stringify(filtered));
      equipmentCommentModal.reinitializePagination(true);
      equipmentCommentModal.commentsLoading = false;
      m.redraw();
      return filtered;
    }).catch(function (error) {
      console.error('Unable to load equipment comments:', error);
      equipmentCommentModal.comments = [];
      equipmentCommentModal.commentsToShow = [];
      equipmentCommentModal.reinitializePagination(true);
      equipmentCommentModal.commentsLoading = false;
      equipmentCommentModal.commentsLoadError = 'Unable to load comments.';
      m.redraw();
      return null;
    });
  },

  isOwner: function (commentRecord) {
    if (!commentRecord) return false;
    const currentUserRid = session.user && session.user()['@rid'];
    const authorRid = commentRecord.user && commentRecord.user['@rid'];
    return currentUserRid && authorRid && currentUserRid === authorRid;
  },
  isSuperUser: function () {
    const user = session.user && session.user();
    return !!(user && (user.isSuperuser === true || user.isSuperuser === 1 || user.isSuperuser === '1'));
  },
  canDelete: function (commentRecord) {
    return equipmentCommentModal.isSuperUser() && !equipmentCommentModal.isOwner(commentRecord);
  },

  getEditingRecord: function () {
    const rid = equipmentCommentModal.editingRid && equipmentCommentModal.editingRid();
    if (!rid) return null;
    return equipmentCommentModal.comments.find(c => c['@rid'] === rid) || null;
  },

  updateButtons: function () {
    const isEditing = equipmentCommentModal.editingRid && equipmentCommentModal.editingRid();
    const buttons = [
      {
        label: 'Submit',
        class: 'dib green',
        func: function () { return equipmentCommentModal.addComment(); }
      }
    ];

    if (isEditing) {
      buttons.unshift({
        label: 'Delete',
        class: 'dib mr2 red',
        func: function () { return equipmentCommentModal.confirmDelete(); }
      });
      buttons.unshift({
        label: 'Cancel',
        class: 'dib mr2',
        func: function () {
          equipmentCommentModal.resetForm();
          m.redraw();
        }
      });
    }

    modal.vm.buttons(buttons);
  },
  resetForm: function () {
    equipmentCommentModal.commentText('');
    equipmentCommentModal.editingRid(null);
    equipmentCommentModal.pendingDeleteRecord = null;
    equipmentCommentModal.updateButtons();
  },

  restoreMainView: function () {
    modal.vm.title(equipmentCommentModal.modalTitle || 'Comments');
    modal.vm.body = equipmentCommentModal.view;
    equipmentCommentModal.updateButtons();
    modal.vm.open({ extrawidth: true });
  },

  confirmDelete: function () {
    const targetRecord = equipmentCommentModal.pendingDeleteRecord || equipmentCommentModal.getEditingRecord();
    if (!targetRecord) return;
    equipmentCommentModal.pendingDeleteRecord = targetRecord;

    modal.vm.title('Delete comment?');
    modal.vm.body = equipmentCommentModal.confirmDeleteView;
    modal.vm.buttons([
      {
        label: 'Cancel',
        class: 'dib mr2',
        func: function () {
          equipmentCommentModal.pendingDeleteRecord = null;
          equipmentCommentModal.restoreMainView();
        }
      },
      {
        label: 'Delete',
        class: 'dib red',
        func: function () {
          const deleteAction = equipmentCommentModal.deleteComment(equipmentCommentModal.pendingDeleteRecord);
          if (deleteAction && typeof deleteAction.then === 'function') {
            return deleteAction.then(function () {
              equipmentCommentModal.pendingDeleteRecord = null;
              equipmentCommentModal.restoreMainView();
            });
          }
          equipmentCommentModal.pendingDeleteRecord = null;
          equipmentCommentModal.restoreMainView();
        }
      }
    ]);
    modal.vm.open({ extrawidth: true });
  },

  confirmDeleteView: function () {
    const record = equipmentCommentModal.pendingDeleteRecord || equipmentCommentModal.getEditingRecord();
    const message = record && record.message ? record.message : '';
    return m('div', [
      m('p', 'Are you sure you want to delete this comment?'),
      message ? m('div.mt3.pa2.br2.ba.b--dashed.b--dark-gray.bg-near-black', [
        m('div.white', message)
      ]) : null
    ]);
  },

  addComment: function () {
    const message = (equipmentCommentModal.commentText() || '').trim();
    if (!message) return;
    const rid = equipmentCommentModal.subjectRid;
    if (!rid) return;

    const editingRid = equipmentCommentModal.editingRid();
    if (editingRid) {
      return loaders.requestWithLoader({
        url: `/api/v1/comment/${editingRid.toString().replace('#', '')}`,
        method: 'PUT',
        body: { message, updatedTimestamp: Date.now(), elementRid: equipmentCommentModal.elementRid }
      }).then(function () {
        equipmentCommentModal.commentText('');
        equipmentCommentModal.editingRid(null);
        equipmentCommentModal.pendingDeleteRecord = null;
        equipmentCommentModal.updateButtons();
        equipmentCommentModal.fetchComments();
        if (equipmentCommentModal.submitCallback) {
          equipmentCommentModal.submitCallback();
        }
      });
    }

    const payload = {
      subjectRecord: rid,
      elementRid: equipmentCommentModal.elementRid,
      timestamp: Date.now(),
      message
    };

    const nextComments = equipmentCommentModal.comments.slice();
    nextComments.unshift({
      message: payload.message,
      timestamp: payload.timestamp,
      '@rid': `temp-${payload.timestamp}`,
      userRid: session.user && session.user()['@rid'],
      user: {
        '@rid': session.user && session.user()['@rid'],
        firstName: session.user && session.user().firstName,
        lastName: session.user && session.user().lastName
      }
    });
    equipmentCommentModal.comments = nextComments;

    return loaders.requestWithLoader({
      url: '/api/v1/comment',
      method: 'POST',
      body: payload
    }).then(function () {
      equipmentCommentModal.commentText('');
      equipmentCommentModal.editingRid(null);
      equipmentCommentModal.pendingDeleteRecord = null;
      equipmentCommentModal.updateButtons();
      equipmentCommentModal.fetchComments();
      if (equipmentCommentModal.submitCallback) {
        equipmentCommentModal.submitCallback();
      }
      equipmentCommentModal.commentsToShow = JSON.parse(JSON.stringify(nextComments));
      equipmentCommentModal.reinitializePagination(true);
      m.redraw();
    });
  },

  editComment: function (commentRecord) {
    if (!equipmentCommentModal.isOwner(commentRecord)) return;
    equipmentCommentModal.editingRid(commentRecord['@rid']);
    equipmentCommentModal.commentText(commentRecord.message || '');
    equipmentCommentModal.updateButtons();
  },

  deleteComment: function (commentRecord) {
    const targetRecord = commentRecord || equipmentCommentModal.getEditingRecord();
    if (!targetRecord || !equipmentCommentModal.canDelete(targetRecord)) return;
    const rid = targetRecord['@rid'];
    if (!rid) return;
    return loaders.requestWithLoader({
      url: `/api/v1/comment/${rid.toString().replace('#', '')}`,
      method: 'DELETE',
      body: { deletedTimestamp: Date.now(), elementRid: equipmentCommentModal.elementRid }
    }).then(function () {
      equipmentCommentModal.comments = equipmentCommentModal.comments.filter(c => c['@rid'] !== rid);
      equipmentCommentModal.editingRid(null);
      equipmentCommentModal.commentText('');
      equipmentCommentModal.pendingDeleteRecord = null;
      equipmentCommentModal.fetchComments();
      if (equipmentCommentModal.submitCallback) {
        equipmentCommentModal.submitCallback();
      }
      equipmentCommentModal.commentsToShow = JSON.parse(JSON.stringify(equipmentCommentModal.comments));
      equipmentCommentModal.reinitializePagination(true);
      m.redraw();
    });
  },

  view: function () {
    if (equipmentCommentModal.commentsLoading) return m('div', 'Loading comments…');
    if (equipmentCommentModal.commentsLoadError) {
      return m('div', [
        m('p.dark-red', equipmentCommentModal.commentsLoadError),
        m('button', { type: 'button', onclick: equipmentCommentModal.fetchComments }, 'Retry')
      ]);
    }
    if (!equipmentCommentModal.comments) return m('div');
    const displayComments = equipmentCommentModal.commentsToShow || [];

    return m('div.w-100', {
      style: { display: equipmentCommentModal.reinitializePagination() ? 'none' : '' }
    }, [
      m('div.overflow-hidden.mb3', [
        m('div.dragscroll-container.w-100', [
          m('div.dragscroll.pb3', { oncreate: dragscroll }, [
            m('table.f3.bg-dark-gray.w-100', { style: { minWidth: '950px', tableLayout: 'fixed' } }, [
              m('thead', [
                m('tr.relative', [
                  m('th.br.tl.bt-0.bl-0.b--dotted.bw1.w-50', { style: { minWidth: '400px' } }, 'Comment'),
                  m('th.br.tl.bt-0.bl-0.b--dotted.bw1.w-20', { style: { minWidth: '200px' } }, 'By'),
                  m('th.br.tl.bt-0.bl-0.b--dotted.bw1.w-20', { style: { minWidth: '200px' } }, 'Time'),
                  m('th.br.tc.bt-0.bl-0.b--dotted.bw1.w-10', { style: { minWidth: '100px' } }, 'Actions')
                ])
              ]),
              m('tbody', displayComments.map(function (commentRecord) {
                const user = commentRecord.user || {};
                return m('tr', [
                  m('td.bb.tl.moon-gray.tl.w-50', { style: { wordWrap: 'break-word', minWidth: '400px' } }, commentRecord.message),
                  m('td.bb.tl.moon-gray.tl.w-20', { style: { minWidth: '200px' } }, (user.firstName || '') + ' ' + (user.lastName || '')),
                  m('td.bb.tl.moon-gray.tl.w-20', { style: { minWidth: '200px' } }, [
                    m('div', 'Created: ' + moment(new Date(commentRecord.timestamp)).format(dateFormat)),
                    commentRecord.updatedTimestamp
                      ? m('div.f6.moon-gray.mt1', 'Updated: ' + moment(new Date(commentRecord.updatedTimestamp)).format(dateFormat))
                      : null
                  ]),
                  m('td.bb.tc.moon-gray.tl.w-10', { style: { minWidth: '100px' } }, [
                    equipmentCommentModal.isOwner(commentRecord)
                      ? m('div.relative', [
                          m('i.pointer.blue.ion-ios-compose.f1', {
                            title: 'Edit comment',
                            onclick: function () { equipmentCommentModal.editComment(commentRecord); }
                          })
                        ])
                      : null,
                    equipmentCommentModal.canDelete(commentRecord)
                      ? m('i.pointer.red.ion-trash-b.f1', {
                          title: 'Delete comment',
                          onclick: function () {
                            equipmentCommentModal.pendingDeleteRecord = commentRecord;
                            equipmentCommentModal.confirmDelete();
                          }
                        })
                      : null
                  ])
                ]);
              }))
            ])
          ])
        ]),
      ]),
      m(pagination, { data: equipmentCommentModal.commentsToShow, reinitializePagination: equipmentCommentModal.reinitializePagination }),
      m('form.mt4', [
        m('label', { for: 'equipment-comment' }, equipmentCommentModal.editingRid() ? 'Edit comment' : 'New Comment:'),
        m('div.mt2', [
          m('textarea', {
            resize: 'none',
            id: 'equipment-comment',
            rows: '5',
            cols: '40',
            'box-sizing': 'border-box',
            placeholder: 'Add your comment here...',
            oninput: function (ev) { equipmentCommentModal.commentText(ev.target.value); },
            value: equipmentCommentModal.commentText()
          })
        ])
      ])
    ]);
  }
};

module.exports = equipmentCommentModal;
